export default function maskedCurrencyToNumber(masked: string) {
  if (!masked) return NaN;

  const [, noPrefixValue] = masked.split(' ');

  if (!noPrefixValue) return NaN;

  return Number(noPrefixValue.replaceAll('.', '').replace(',', '.'));
}
